import React from "react";
import SegmentedControl from "@ingka/segmented-control";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/segmented-control/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaSegmentedControlItem = {
  label: string;
  type?: "submit" | "reset" | "button" | undefined;
};

interface SegmentedControlProps {
  className?: string;
  items: FixaSegmentedControlItem[];
  onClick: (e: React.MouseEvent<HTMLButtonElement>, index: number) => void;
  activeIndex: number;
  size?: "small" | "medium" | "large";
}

export const FixaSegmentedControl = (props: SegmentedControlProps) => {
  return <SegmentedControl {...props} />;
};
